import Resource from './Resource';

export default class Gradelevels extends Resource {
	constructor(options={}) {
		let {
			route = 'district/gradelevels',
		} = options;

		let config = {
			route: route
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
